/**
 * Central brand configuration — ADD-012/039, BRD-01, §10.3.
 * Public product strings live only here; components read this module and never
 * hard-code the product name, contact or legal references.
 */

export interface BrandConfig {
  readonly product_name: string
  /** The wordmark's two parts: ink, then signature blue. Together they spell `product_name`. */
  readonly wordmark: readonly [ink: string, accent: string]
  readonly descriptor: string
  readonly legal_entity: string
  readonly domain: string
  /** Exception contact for security, privacy, purchase and data-loss issues. */
  readonly exception_contact: string
  readonly support_hours: string
  readonly support_acknowledgement: string
  readonly privacy_url: string
  readonly terms_url: string
  readonly store_descriptors: {
    readonly ios: string
    readonly android: string
  }
}

export const BRAND: BrandConfig = {
  product_name: 'SignBento',
  wordmark: ['Sign', 'Bento'],
  descriptor: 'Sign, send and track agreements without an account for local work.',
  legal_entity: 'Instadyn LLC',
  domain: 'signbento.com',
  exception_contact: 'support@instadyn.com',
  support_hours: 'published business hours',
  support_acknowledgement: 'within two business days',
  privacy_url: 'https://signbento.com/privacy',
  terms_url: 'https://signbento.com/terms',
  store_descriptors: {
    ios: 'SignBento — sign and send agreements',
    android: 'SignBento — sign and send agreements',
  },
}
